import React from 'react'

let SpinnerWhenInvalid = ({ isInvalid, children }) => (
    !isInvalid ? children : (<span className="fa fa-spinner fa-spin fa-2x"></span>)
);

export default SpinnerWhenInvalid;


// WEBPACK FOOTER //
// ./src/Components/checkout/components/Spinner/SpinnerWhenInvalid.jsx